import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeNotification } from "../store/slices/notificationSlice";
import "./FloatingNotification.css";
import { RootState } from "../store/store";

const FloatingNotification: React.FC = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(
    (state: RootState) => state.notifications.notifications
  );
  const [fadingIds, setFadingIds] = useState<string[]>([]);

  useEffect(() => {
    notifications.forEach((notification) => {
      const timer = setTimeout(() => {
        setFadingIds((prev) => [...prev, notification.id]);
        setTimeout(() => {
          dispatch(removeNotification(notification.id));
          setFadingIds((prev) => prev.filter((id) => id !== notification.id));
        }, 300); // Match the fade-out animation duration
      }, 5000);

      return () => clearTimeout(timer);
    });
  }, [notifications, dispatch]);

  const handleClose = (id: string) => {
    setFadingIds((prev) => [...prev, id]);
    setTimeout(() => {
      dispatch(removeNotification(id));
      setFadingIds((prev) =>
        prev.filter((notificationId) => notificationId !== id)
      );
    }, 300);
  };

  return (
    <div className="floating-notifications">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification ${notification.type} ${
            fadingIds.includes(notification.id) ? "fade-out" : ""
          }`}
        >
          <span>{notification.message}</span>
          <button
            className="close-button"
            onClick={() => handleClose(notification.id)}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default FloatingNotification;
